<template>
    <div>
        <van-row>
            <van-col v-for="(param, i) in paramList" :key="i" span="6">
                <div class="m-l-4 m-r-4 sku-item"
                     :class="{'sku-item-normal': pickedNum != i, 'sku-item-checked': pickedNum == i}"
                     @click="numChange(i)">
                    {{param.defautValue}}{{unit}}
                </div>
            </van-col>
            <van-col :key="paramList && paramList.length" span="6">
                <div class="m-l-4 m-r-4 sku-item"
                     :class="{'sku-item-normal': pickedNum != 'custom', 'sku-item-checked': pickedNum == 'custom'}"
                     @click="numChange('custom')">
                    自定义
                </div>
            </van-col>
        </van-row>
        <div v-if="pickedNum == 'custom'">
            <!-- 客户服务 -->
            <van-stepper v-if="combineCode == 'CUSTOMER_SERVICE'"
                         v-model="pickedNumCustom"
                         integer
                         :step="10000"
                         @change="numInputChange"
                         input-width="100px"
                         :min="10000"
                         :max="10000000"></van-stepper>
            <!-- 云盘 -->
            <van-stepper v-if="combineCode == 'STORE_SERVICE'"
                         v-model="pickedNumCustom"
                         integer
                         :step="100"
                         @change="numInputChange"
                         input-width="100px"
                         :min="100"
                         :max="10000000"></van-stepper>
            <!-- 短信 -->
            <van-stepper v-if="combineCode == 'MESSAGE_SERVICE'"
                         v-model="pickedNumCustom"
                         integer
                         :step="20000"
                         input-width="100px"
                         @change="numInputChange"
                         :min="20000"
                         :max="10000000"></van-stepper>
            <van-stepper v-if="combineCode == 'YYZWZ_SERVICE'"
                         v-model="pickedNumCustom"
                         integer
                         :step="100"
                         input-width="100px"
                         @change="numInputChange"
                         :min="100"
                         :max="10000000"></van-stepper>
        </div>
        <div
            v-if="combineCode == 'MESSAGE_SERVICE' && pickedNumData"
            style="font-size: 12px; color: #a4afbc; padding: 8px; background-color: #f0f0f0; border-radius: 5px">
            <span>
                {{`${(pickedNumData.unitPrice / pickedNumData.unitNum / 100).toFixed(3)}元/条`}}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'va-customer-sku',
        data() {
            return {
                pickedNum: -1,
                pickedNumCustom: '',
                pickedNumData: ''
            };
        },
        props: {
            paramList: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            unit: {
                default: function () {
                    return '';
                }
            },
            combineCode: {
                default: function () {
                    return '';
                }
            }
        },
        methods: {
            // 数量 短信 云盘 客户数
            numChange(i) {
                this.pickedNum = i;
                let L = _.cloneDeep(this.paramList);
                if (this.pickedNum == 'custom') {
                    this.numInputChange();
                    return;
                }
                this.pickedNumData = L[this.pickedNum];
                this.payPriceChange();
            },
            // 自定义数量
            numInputChange(val) {
                console.log('numInputChange', this.pickedNumCustom, val);
                setTimeout(() => {
                    // let num = val || this.pickedNumCustom;
                    let num = this.pickedNumCustom;
                    let L = _.cloneDeep(this.paramList);
                    L.map((item) => {
                        if ((num >= item.minValue) && (num <= item.maxValue)) {
                            this.pickedNumData = _.cloneDeep(item);
                        }
                    });
                    if (num < L[0].minValue) {
                        this.pickedNumData = L[0];
                    }
                    if (num > L[L.length - 1].maxValue) {
                        this.pickedNumData = L[L.length - 1];
                    }
                    if (this.pickedNum == 'custom') {
                        this.pickedNumData.defautValue = num;
                    }
                    this.payPriceChange();
                }, 200);
            },

            // 计算价格
            payPriceChange() {
                let price = 0;
                // 数量 短信 云盘 客户数
                if (this.pickedNumData.defautValue && this.pickedNumData.unitPrice && this.pickedNumData.unitNum) {
                    price = (Math.round(this.pickedNumData.defautValue * this.pickedNumData.unitPrice / this.pickedNumData.unitNum) / 100) || 0;
                    if (this.combineCode !== 'MESSAGE_SERVICE' && this.pickedNumData.endDayNum > 0) {
                        price = (price / 365 * this.pickedNumData.endDayNum);
                    }
                } else {
                    price = 0;
                }
                this.$emit('onPriceChanged', this.pickedNumData, price, this.pickedNumData.defautValue + this.unit);
            }
        }
    };
</script>

<style scoped>
    .sku-item {
        font-size: 12px;
        color: #07affa;
        text-align: center;
        border: #07affa 1px solid;
        border-radius: 4px;
        line-height: 27px;
        margin-bottom: 15px
    }

    .sku-item-normal {
        color: #28405e;
        border-color: #eee;
    }

    .sku--item-checked {
        color: #07affa;
        border-color: #07affa;
    }
</style>
